<template>
    <div class="resource-download" :class="{'resource-download--is-page-loaded': isPageLoaded}">
        <h3 class="resource-download__title">{{ asText(document.data.ungateTitle) }}</h3>
        <VJoyButton :label="document.data.ungateLink?.text" variant="main" :href="ungateWebHref" />
    </div>
</template>

<script lang="ts" setup>
    import {ref, onMounted, computed} from 'vue';
    import {isFilled} from '@prismicio/client';
    import {asText} from '@prismicio/helpers';
    import type {GuideDocument} from '@prismicio-types';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useUpdateStickyFormOffset} from '~/composables/useUpdateStickyFormOffset';

    const props = defineProps<{
        document: GuideDocument;
    }>();

    const ungateWebHref = computed(() => {
        const link = props.document.data.ungateLink;
        return isFilled.link(link) && link.link_type === 'Web' ? link.url : undefined;
    });

    const isPageLoaded = ref(false);

    onMounted(() => (isPageLoaded.value = true));
    useUpdateStickyFormOffset();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .resource-download {
        position: relative;
        z-index: 1;
        padding: var(--joy-core-spacing-6);
        margin-bottom: var(--joy-core-spacing-2);
        background-color: var(--joy-color-background-default);
        border-radius: var(--joy-core-radius-3);
        border: solid 1px var(--joy-color-neutral-30);

        @include mq.screen_md(min) {
            opacity: 0;
            transition: opacity var(--joy-transition-duration-default) var(--joy-transition-timing-function);

            &--is-page-loaded {
                opacity: 1;
            }
        }

        &__title {
            font-family: var(--joy-font-family-title);
            font-weight: var(--joy-font-weight-bold);
            font-size: var(--joy-font-size-primary-600);
            margin-bottom: var(--joy-core-spacing-6);

            @include mq.screen_md(min) {
                font-size: var(--joy-font-size-secondary-200);
            }
        }

        .joy-button {
            width: 100%;

            @include mq.screen_sm(min) {
                display: block;
                width: initial;
                margin: 0 auto;
            }
        }
    }
</style>
